export const MODAL_HIDE = 'syftacp/MODAL_HIDE' as const
export const MODAL_SHOW = 'syftacp/MODAL_SHOW' as const
export const MODAL_SET_DATA = 'syftacp/MODAL_SET_DATA' as const
